/**
 * @member {Number} id
 * @member {string|null} email
 * @member {string|null} phone
 * @member {string|null} name
 * @member {string|null} info
 * @member {string} role
 * @member {Number} organization_id
 * @member {Boolean} isTerminalStaff
 * @member {Array} subdivisions
 */
export default class ApplicationLogDto {
  id
  email
  phone
  name
  info
  role
  organization_id
  isTerminalStaff
  subdivisions

  /**
   * @param {Number} id
   * @param {string|null} email
   * @param {string|null} phone
   * @param {string|null} name
   * @param {string|null} info
   * @param {string} role
   * @param {Number} organization_id
   * @param {Boolean} isTerminalStaff
   * @param {String[]} subdivisions
   */
  constructor({
    id,
    email,
    phone,
    name,
    info,
    role,
    organization_id,
    isTerminalStaff,
    subdivisions
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    id = Number(id)
    email = email || email === '' ? String(email) : null
    phone = phone || phone === '' ? String(phone) : null
    name = name || name === '' ? String(name) : null
    info = info || info === '' ? String(info) : null
    role = String(role)
    organization_id = Number(organization_id)
    isTerminalStaff = Boolean(isTerminalStaff)
    subdivisions = Array.isArray(subdivisions) ? subdivisions.map(String) : []

    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties))
    Object.defineProperty(this, 'email', Object.assign({ value: email }, properties))
    Object.defineProperty(this, 'phone', Object.assign({ value: phone }, properties))
    Object.defineProperty(this, 'name', Object.assign({ value: name }, properties))
    Object.defineProperty(this, 'info', Object.assign({ value: info }, properties))
    Object.defineProperty(this, 'role', Object.assign({ value: role }, properties))
    Object.defineProperty(this, 'organization_id', Object.assign({ value: organization_id }, properties))
    Object.defineProperty(this, 'isTerminalStaff', Object.assign({ value: isTerminalStaff }, properties))
    Object.defineProperty(this, 'subdivisions', Object.assign({ value: subdivisions }, properties))

    Object.freeze(this)
  }
}
